import { ThemeProvider } from "themes/ThemeProvider"
import AuthProvider, { useAuthContext } from "contexts/AuthContext"
import StudentAuthProvider from "contexts/StudentAuthContext"
import TeacherAuthProvider from "contexts/TeacherAuthContext"
import { USER_TYPES, STAFF_TYPES } from "common/constants"
import Layouts from "components/Layouts"
import { BrowserRouter } from "react-router-dom"
import GlobalAlertProvider from "contexts/GlobalAlertContext"
import { AlertQueueProvider } from "contexts/AlertQueueContext"
import { ToastProvider } from "contexts/ToastContext"
import "semantic-ui-css/semantic.min.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import ThemeContextProvider from "contexts/ThemeContext"

const AuthSubProviders = ({ children }) => {
  const { userData } = useAuthContext()
  const isStudentOrStaff =
    userData?.userTypeId === USER_TYPES.STUDENT ||
    STAFF_TYPES.includes(userData?.userTypeId)
  if (isStudentOrStaff) {
    return <StudentAuthProvider>{children}</StudentAuthProvider>
  }
  if (userData?.userTypeId === USER_TYPES.TEACHER) {
    return <TeacherAuthProvider>{children}</TeacherAuthProvider>
  }
  return children
}

export const App = () => {
  return (
    <ThemeContextProvider>
      <ThemeProvider>
        <ToastProvider>
          <GlobalAlertProvider>
            <AlertQueueProvider>
              <BrowserRouter
                basename={
                  document.querySelector("base")?.getAttribute("href") ?? "/"
                }
              >
                <AuthProvider>
                  <AuthSubProviders>
                    <Layouts />
                  </AuthSubProviders>
                </AuthProvider>
              </BrowserRouter>
            </AlertQueueProvider>
          </GlobalAlertProvider>
        </ToastProvider>
      </ThemeProvider>
    </ThemeContextProvider>
  )
}
